export const DELETE_GROUP = 'DELETE_GROUP';
export const REORDER_GROUP = 'REORDER_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';

export const ADD_FORM = 'ADD_FORM';
export const REMOVE_FORM = 'REMOVE_FORM';
export const REORDER_FORM = 'REORDER_FORM';

export const GENERIC_ERROR = 'GENERIC_ERROR';
